import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["name", "min", "max", "required", "data-fehlermeldung", "data-cy"]
const _hoisted_2 = ["name", "required", "data-cy"]
const _hoisted_3 = ["name", "required", "aria-required", "data-cy"]
const _hoisted_4 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_zeile, { class: "u-mar-t-1" }, {
      default: _withCtx(() => [
        _createVNode(_component_titel_zelle, null, {
          default: _withCtx(() => [
            _createTextVNode(" Jahr des " + _toDisplayString(_ctx.vorschadenId) + ". Schadens", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_zelle, { breite: 3 }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: _ctx.vorschadenJahrMitId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.piniaStore.state.ferienhaus[_ctx.sparte].vorschaeden[_ctx.vorschadenId - 1].schadenjahr) = $event)),
              class: "c-form-control__input",
              placeholder: "JJJJ",
              min: _ctx.schadenJahrMin,
              max: _ctx.jahrHeute,
              minlength: "4",
              maxlength: "4",
              required: _ctx.piniaStore.state.ferienhaus[_ctx.sparte].tarifinformationen.vorschaedenAnzahl >= 1,
              "data-checknummer": "true",
              "data-fehlermeldung": 
          'Bitte geben Sie das vierstellige Schadenjahr ein (' + _ctx.schadenJahrMin + '-' + _ctx.jahrHeute + ').'
        ,
              "data-cy": 'vorschadenSchadensJahr' + (_ctx.vorschadenId - 1)
            }, null, 8, _hoisted_1), [
              [
                _vModelText,
                _ctx.piniaStore.state.ferienhaus[_ctx.sparte].vorschaeden[_ctx.vorschadenId - 1].schadenjahr,
                void 0,
                {
                  lazy: true,
                  trim: true,
                  number: true
                }
              ]
            ]),
            _createVNode(_component_validierungs_fehler, {
              "fehler-text": _ctx.fehler[_ctx.vorschadenJahrMitId]
            }, null, 8, ["fehler-text"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_zeile, null, {
      default: _withCtx(() => [
        _createVNode(_component_titel_zelle, null, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode("Schadenhöhe")
          ])),
          _: 1,
          __: [4]
        }),
        _createVNode(_component_zelle, { breite: 3 }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              type: "number",
              onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.erzwingeGanzzahl && _ctx.erzwingeGanzzahl(...args))),
              name: _ctx.vorschadenHoeheMitId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.piniaStore.state.ferienhaus[_ctx.sparte].vorschaeden[_ctx.vorschadenId - 1].schadenhoehe) = $event)),
              class: "c-form-control__input",
              placeholder: "Schadenhöhe in EUR",
              min: "0",
              max: "2000000",
              required: _ctx.piniaStore.state.ferienhaus[_ctx.sparte].tarifinformationen.vorschaedenAnzahl >= 1,
              "data-checknummer": "true",
              "data-fehlermeldung": "Bitte geben Sie die Schadenhöhe in vollen Euro ohne Leer- und Sonderzeichen ein.",
              "data-cy": 'vorschadenSchadensHoehe' + (_ctx.vorschadenId - 1)
            }, null, 40, _hoisted_2), [
              [
                _vModelText,
                _ctx.piniaStore.state.ferienhaus[_ctx.sparte].vorschaeden[_ctx.vorschadenId - 1].schadenhoehe,
                void 0,
                {
                  lazy: true,
                  trim: true,
                  number: true
                }
              ]
            ]),
            _createVNode(_component_validierungs_fehler, {
              "fehler-text": _ctx.fehler[_ctx.vorschadenHoeheMitId]
            }, null, 8, ["fehler-text"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.zeigeSchadenart)
      ? (_openBlock(), _createBlock(_component_zeile, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_titel_zelle, null, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("Schadenart")
              ])),
              _: 1,
              __: [5]
            }),
            _createVNode(_component_zelle, null, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("select", {
                  name: _ctx.vorschadenTypMitId,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.piniaStore.state.ferienhaus[_ctx.sparte].vorschaeden[_ctx.vorschadenId - 1].schadenart) = $event)),
                  class: "c-form-control-select",
                  required: _ctx.piniaStore.state.ferienhaus[_ctx.sparte].tarifinformationen.vorschaedenAnzahl >= 1,
                  "aria-required": _ctx.piniaStore.state.ferienhaus[_ctx.sparte].tarifinformationen.vorschaedenAnzahl >= 1,
                  "aria-label": "Schadenart",
                  "data-fehlermeldung": "Bitte wählen Sie eine Schadenart aus.",
                  "data-cy": 'vorschadenSchadensArt' + (_ctx.vorschadenId - 1)
                }, [
                  _cache[6] || (_cache[6] = _createElementVNode("option", { value: "" }, "Bitte wählen", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schadenarten, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: item.value,
                      key: item.value
                    }, _toDisplayString(item.text), 9, _hoisted_4))
                  }), 128))
                ], 8, _hoisted_3), [
                  [
                    _vModelSelect,
                    _ctx.piniaStore.state.ferienhaus[_ctx.sparte].vorschaeden[_ctx.vorschadenId - 1].schadenart,
                    void 0,
                    {
                      lazy: true,
                      trim: true
                    }
                  ]
                ]),
                _createVNode(_component_validierungs_fehler, {
                  "fehler-text": _ctx.fehler[_ctx.vorschadenTypMitId],
                  "reduzierter-abstand": true
                }, null, 8, ["fehler-text"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}